"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _modal_type = require('redux/actions/modal_type');

var _components2 = require('components');

require('./headerWishIcon.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    ProductWishIcon: {
        displayName: 'ProductWishIcon'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/WishList/HeaderWishIcon/HeaderWishIcon.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var ProductWishIcon = _wrapComponent('ProductWishIcon')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        wishProducts: state.wishList.wishProducts,
        user: state.auth.user
    };
}, { showModalAuth: _modal_type.showModalAuth }), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(ProductWishIcon, _Component);

    function ProductWishIcon(props) {
        (0, _classCallCheck3.default)(this, ProductWishIcon);
        return (0, _possibleConstructorReturn3.default)(this, (ProductWishIcon.__proto__ || (0, _getPrototypeOf2.default)(ProductWishIcon)).call(this, props));
    }

    (0, _createClass3.default)(ProductWishIcon, [{
        key: 'render',
        value: function render() {
            var wishProducts = this.props.wishProducts;

            if (wishProducts === null) {
                wishProducts = [];
            }
            var classActive = wishProducts.length > 0 ? " active_wish " : "";
            var isActive = wishProducts.length ? " active_icon" : "";

            var content = _react3.default.createElement(
                'div',
                { className: 'header_icon-holder' },
                _react3.default.createElement('i', { className: "fa fa-heart header_icon " + isActive }),
                wishProducts.length > 0 ? _react3.default.createElement(
                    'div',
                    { className: 'header_icon_text-holder' },
                    _react3.default.createElement(
                        'span',
                        { className: 'header_icon_text' },
                        wishProducts.length
                    )
                ) : null
            );

            return _react3.default.createElement(
                _reactRouter.Link,
                { to: '/wishlist' },
                content
            );
        }
    }]);
    return ProductWishIcon;
}(_react2.Component), _class2.propTypes = {
    //product: PropTypes.obj.isRequired
}, _temp)) || _class));

exports.default = ProductWishIcon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/WishList/HeaderWishIcon/HeaderWishIcon.jsx
// module id = 1790
// module chunks = 0